import { useState, useEffect } from "react";
import AddQuestions from "./AddQuestions";
import { RiArrowGoBackFill } from "react-icons/ri";
import { FaCheck, FaPlus, FaMinus } from "react-icons/fa6";
import axios from "axios";
import { BASE_URL } from "../constants";
import { Hidden } from "@mui/material";

export default function FooterActivities({
    questions,
    setHitQuestion,
    setQuestions,
    setFullStyle,
    videoRef,
    interactiveMode,
    setIsPlaying,
    hitQuestion,
    onProgressEvents, setOnProgressEvents,
    question, setQuestion
}) {
    const [timestamp, setTimestamp] = useState(question?.time);
    useEffect(()=>{
        setTimestamp(question?.time);
    }, [question])

    const handleUpdateTimestamp = () => {
        axios.put(`${BASE_URL}/lesson/updateQuestionTime.php?questionId=${question.id}`, { timestamp })
        .then(res => {
            setQuestion({...question, time: res.data.data.timestamp})
            questions[questions.indexOf(question)] = {...question, time: res.data.data.timestamp}
        }).catch(err => {
            console.log(err);
        })
    }
    return (
        <div className='activities rounded-b-lg'>
            {
                question && hitQuestion ?
                    <div className="flex w-full justify-center items-center">
                        {
                            timestamp != question.time &&
                            <button
                                className="text-lightAqua hover:bg-sky-600 hover:text-gray-300 active:bg-sky-700 active:text-gray-300 rounded-full mr-5 p-1 h-full w-fit"
                                onClick={() => setTimestamp(question.time)}
                            >
                                <RiArrowGoBackFill fontSize={30} />
                            </button>
                        }
                        <button
                            className="text-red-600 hover:bg-red-600 hover:text-gray-300 active:bg-red-700 active:text-gray-300 rounded-full mr-2 p-1 h-full w-fit"
                            onClick={() => setTimestamp(+timestamp - 1)}
                        >
                            <FaMinus fontSize={30} />
                        </button>

                        <input
                            type="text" value={timestamp} onChange={(e) => setTimestamp(e.target.value)}
                            className="text-center w-1/6 rounded-full py-1 text-lg font-bold bg-gray-300"
                        />

                        <button
                            className="text-green-600 hover:bg-green-700 hover:text-gray-300 rounded-full active:bg-green-800 active:text-gray-300 ml-2 p-1 h-full w-fit"
                            onClick={() => setTimestamp(+timestamp + 1)}
                        >
                            <FaPlus fontSize={30} />
                        </button>

                        {
                            timestamp != question.time &&
                            <button
                                className="text-lightAqua hover:bg-sky-600 hover:text-gray-300 active:bg-sky-700 active:text-gray-300 rounded-full ml-5 p-1 h-full w-fit"
                                onClick={handleUpdateTimestamp}
                            >
                                <FaCheck fontSize={30} />
                            </button>
                        }
                    </div>
                    : null
            }<div style={{overflow:"hidden",width:`${question && hitQuestion? "0px":"fit-content"}`}}>
                <AddQuestions
                        questions={questions} setQuestions={setQuestions} setFullStyle={setFullStyle}
                        setHitQuestion={setHitQuestion} videoRef={videoRef} setIsPlaying={setIsPlaying}
                        hitQuestion={hitQuestion}
                        onProgressEvents={onProgressEvents} setOnProgressEvents={setOnProgressEvents}
                    />
            </div>
        </div>

    )
}
